// extracted by mini-css-extract-plugin
export default {"actions":"styles_actions__tbZOk","title":"styles_title__NhpAK"};